module.exports = __webpack_public_path__ + "static/media/ic-more-black-24.dcdd7ae7.svg";